import { HttpHandler, HttpMiddleware } from '../http/middleware.ts';
import { Provide } from '../ioc-container/ioc-container.ts';
import { HttpResponse } from '../http/response.ts';
import { AuthService } from './auth.service.ts';
import { HttpRequest } from '../http/request.ts';
import { inject } from 'inversify';

@Provide(HttpMiddleware)
export class AuthTokenMiddleware implements HttpMiddleware {
	constructor(@inject(AuthService) private authService: AuthService) {}

	async handle(request: HttpRequest, next: HttpHandler): Promise<HttpResponse> {
		if (!this.authService.authenticated) {
			console.debug('Not authenticated, not attaching token.');
			return await next.handle(request);
		}
		const response = await this.executeRequest(request, next);

		if (response.status !== 401) {
			return response;
		}

		try {
			console.debug('Access token seems to be expired, trying to refresh.');
			await this.authService.loginInBackground();
		} catch (err) {
			console.debug('Could not refresh access token, redirecting to login.');
			await this.authService.login();
		}

		console.debug('Retrying request with new access token.');
		return this.executeRequest(request, next);
	}

	private async executeRequest(request: HttpRequest, next: HttpHandler): Promise<HttpResponse> {
		const authorizedRequest = { ...request, headers: new Headers(request.headers) };
		authorizedRequest.headers.set('X-API-Key', this.authService.token);
		const response = await next.handle(authorizedRequest);

		return response;
	}
}
